import { cache, loadApp, unLoadModule } from '@weareduet/core';

// Explicit glob so the build never sweeps `*.test.js` into the bundle.
// Vite 8's `import.meta.glob` has no `ignore` option — use a negative pattern.
const behaviours = import.meta.glob([
	'../behaviours/*.js',
	'!../behaviours/*.test.js',
]);

let app;

function loadBehaviour(name) {
	const load = behaviours[`../behaviours/${name}.js`];

	if (!load) {
		return Promise.reject(new Error(`Unknown behaviour: ${name}`));
	}

	return load();
}

function ensureApp(root = document.body) {
	if (!app) {
		app = loadApp(loadBehaviour, root);
	}

	return app;
}

export function hydrateBehaviours(root = document.body) {
	const instance = ensureApp(root);
	instance.hydrate(root);

	return instance;
}

export function destroyModule(id) {
	unLoadModule(id);
}

export function destroyBehavioursWithin(root = document.body) {
	const instance = ensureApp();
	instance.destroyWithin(root);
}

/**
 * Destroys the behaviour rooted on exactly `node` — not its descendants, and
 * only when the cached module is bound to this very element (a same-id node
 * elsewhere is left alone). No-op for a node that holds no behaviour.
 *
 * @param {Element} node
 * @return {boolean} true when a module was destroyed
 */
export function destroyBehaviour(node) {
	const entry = node?.id ? cache.get(node.id) : undefined;
	if (!entry || entry.node !== node) return false;

	unLoadModule(node.id);
	return true;
}
